<template>
  <v-card class="add-new-org__card">
    <div class="add-new-org__title h3">Organisation Details</div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">
          Organisation name
        </div>
        <form-group :validations="$v.organisation.name" class="form-group">
          <div slot-scope="{ errors }">
            <v-text-field
              :error="true"
              name="name"
              dense
              outlined
              required
              v-model="$v.organisation.name.$model"
              placeholder="Type here..."
              :hide-details="true"
            >
            </v-text-field>
            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>
      </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">
          Primary contact name
        </div>
        <form-group
          :validations="$v.organisation.contact_name"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              outlined
              dense
              id="primary-contact"
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.contact_name.$model"
            >
            </v-text-field>
            <div class="form-field-error">{{ errors[0] || "" }}</div>
          </div>
        </form-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">Email address</div>
        <form-group
          :validations="$v.organisation.contact_email"
          class="form-group"
        >
          <div slot-scope="{ errors }">
            <v-text-field
              outlined
              dense
              hide-details="auto"
              placeholder="Type here..."
              v-model="$v.organisation.contact_email.$model"
            />
            <div class="form-field-error">
              {{ (errors && errors[0]) || "" }}
            </div>
          </div>
        </form-group>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6">
        <div class="small-extra-bold ">Telephone number</div>
        <form-group
          :validations="$v.organisation.contact_number"
          class="form-group"
        >
          <v-text-field
            outlined
            dense
            hide-details="auto"
            placeholder="Type here..."
            v-model="$v.organisation.contact_number.$model"
          >
          </v-text-field>
        </form-group>
      </v-col>
    </v-row>
    <div class="apio__card-actions">
      <apio-button button-type="secondary" @click="cancel">Cancel</apio-button>
      <apio-button @click="save" :disabled="!isFormValid">Continue</apio-button>
    </div>
  </v-card>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  name: "OrgDetails",
  props: {
    organisationDetails: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      title: "",
      organisation: {
        name: "",
        contact_email: "",
        contact_name: "",
      },
    };
  },
  validations: {
    organisation: {
      name: {
        required,
        minLength: minLength(4),
      },
      contact_name: {
        required,
        minLength: minLength(4),
      },
      contact_email: {
        required,
        email,
      },
      contact_number: {
      },
    },
  },
  mixins: [validationMixin],
  components: {
    ApioButton: () => import("@/components/Misc/Button.vue"),
    FormGroup: () => import("@/pages/Account/FormGroup"),
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
    currentOrganisation() {
      return this.$store.state.currentOrganisation;
    },
  },
  created() {
    if(this.$route.params.id) { 
      Object.assign(this.organisation, this.organisationDetails);
      this.$forceUpdate();
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    save() {
      const { name, contact_email, contact_name } = this.organisation
      this.$emit("step", { org: { name, contact_email, contact_name }, step: 2 });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-org {
  &__card {
    color: var(--apio-shade-2);
  }
  &__title {
    padding-bottom: 24px;
  }
}
</style>